export const initialStepList = [
  'Crea tu cuenta',
  'Completa tu perfil',
  'Datos opcionales',
];
